export type WikiGame = {
  key: string;
  name: string;
  title: string;
  description: string;
  heroGameId: string;
  heroTitle?: string;
  heroEyebrow?: string;
};

export const wikiGameRegistry: Record<string, WikiGame> = {
  'guardian-tales': {
    key: 'guardian-tales',
    name: '坎公骑冠剑',
    title: '坎公骑冠剑 Wiki',
    description: '角色图鉴、版本攻略、玩家社区与实用工具。',
    heroGameId: 'guardian-tales',
    heroTitle: '坎公骑冠剑 Wiki',
    heroEyebrow: 'GUARDIAN TALES · COMMUNITY WIKI',
  },
  arcanatactics: {
    key: 'arcanatactics',
    name: '阿尔克纳',
    title: '阿尔克纳 Wiki',
    description: '角色图鉴、版本攻略、玩家社区与实用工具。',
    heroGameId: 'arcanatactics',
    heroTitle: '阿尔克纳wiki攻略站',
    heroEyebrow: 'ARCANA TACTICS · COMMUNITY WIKI',
  },
  lostsword: {
    key: 'lostsword',
    name: '失落之剑',
    title: '失落之剑 Wiki',
    description: '角色图鉴、版本攻略、玩家社区与实用工具。',
    heroGameId: 'lostsword',
    heroTitle: '失落之剑 Wiki',
    heroEyebrow: 'LOST SWORD · COMMUNITY WIKI',
  },
};

export function getWikiGame(slug: string): WikiGame | undefined {
  return wikiGameRegistry[slug];
}

export function listWikiGames(): WikiGame[] {
  return Object.values(wikiGameRegistry);
}
